import Finance from '@/types/database/finance';
import { FormValues } from './type';

const createFinanceRecord = (value: FormValues, houseDetail: any): Finance => ({
  billTime: value.paymentPeriod.format('YYYYMM'),
  householdNumber: value.householdNumber.join('-'),
  userName: houseDetail.userName ? houseDetail.userName : '',
  title: value.title,
  money: value.money,
  remark: value?.remark || '',
  creditSubjectId: value.creditSubjectId,
  subjectId: value.accountingSubjectId,
  residentId: houseDetail._id,
  paymentPeriod: value.paymentPeriod.valueOf(),
});

export { createFinanceRecord };
